export default __webpack_public_path__ + "static/media/books.38664fa5.svg";